import { Component, ChangeDetectionStrategy } from "@angular/core";
import { AppliedCouponsComponent } from "@spartacus/cart/base/components";

@Component({
  selector: 'cx-applied-coupons',
  templateUrl: './custom-applied-coupons.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomAppliedCouponsComponent extends AppliedCouponsComponent {}
